import { Pie } from 'vue-chartjs'
import randomcolor from 'randomcolor';
import _ from 'lodash';

export default {
    extends: Pie,
    props: ['data'],
    watch: {
        data: function (newValue) {

        }
    },
    created() {

    },
    mounted() {
        this.renderChart({
            labels: _.map(this.data.projects, 'name'),
            datasets: [
                {
                    backgroundColor: randomcolor({
                        luminosity: 'light',
                        count: _.map(this.data.projects, 'name').length,
                        hue: 'monochrome'
                    }),
                    data: _.map(this.data.projects, 'totalHours')
                }
            ]
        },
            {
                responsive: true,
                maintainAspectRatio: false
            })
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Analytics/UsersPerProject/PieExample.js